import React from 'react';
import ColonyActions from './ColonyActions';
import MyColonies from './MyColonies';
import { useTranslation } from '../i18n';

export default function ColoniesSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-background py-12 text-primary">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-8">{t('colonies.findPeople')}</h2>
        <div className="flex flex-col lg:flex-row gap-6 justify-between">
          <div className="w-full lg:w-1/2 bg-secondary p-6 rounded-lg shadow">
            <h3 className="text-xl font-semibold mb-4">{t('colonies.exploreColonies')}</h3>
            <ColonyActions />
          </div>
          <div className="w-full lg:w-1/2 bg-secondary p-6 rounded-lg shadow">
            <h3 className="text-xl font-semibold mb-4">{t('colonies.yourColonies')}</h3>
            <MyColonies />
          </div>
        </div>
      </div>
    </section>
  );
}
